import React, { useState, useEffect } from "react";
import * as authActions from "../../../../AxiosRtk/Auth";
import { AlertModal } from "../../../../../../setup/alert/swalAlert";
import { alertIconType } from "../../../../../../setup/alert/iconTypes";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import useLangTranslation from "../../../../../customHooks/languageProvider";
import AuthTermsService from "../../../../../shared/Components/AuthTermsService";
import LoadingIndicator from "../../../../../../setup/Loader/LoaderIndicator";
import { setShowMessage } from "../../../../AxiosRtk/successMessage";

const ForgotPassword = () => {
  const [loader, setLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const history = useHistory();
  const { verificationCode, setForgotPwdToken } = authActions;
  const dispatch = useDispatch();
  const { getLangTranslation } = useLangTranslation();

  function handleInputChange(e) {
    setEmail(e.target.value);
  }

  function handleSubmit() {

    if (!email) {
      setError("SIGN_UP_EMAIL_IS_REQUIRED_ERR")
      return;
    }

    setLoader(true);
    verificationCode(email)
      .then((res) => {
        {
          /* AlertModal(res?.data?.message, alertIconType.successIcon);*/
        }

        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: res?.data?.message,
            message: res?.data?.message,
          })
        );
        dispatch(
          setForgotPwdToken({
            forgotPwdToken: res?.data?.result[0]?.token,
            forgotPwdEmail: email,
          })
        );
        setTimeout(() => {
          history.push("/auth/verification-code");
        }, 3000);
      })
      .catch((err) => {
        AlertModal(
          getLangTranslation(err.response.data.message),
          alertIconType.errorIcon
        );
      })
      .finally(() => {
        setLoader(false);
      });
  }

  useEffect(() => {
    dispatch(setForgotPwdToken({ forgotPwdToken: null, forgotPwdEmail: null }));
  }, []);

  return (
    <>
      <div className="container">
        <div className="auth-wrapper">
          <div className="auth-inner">
            <h2 className="text-center mb-3">
              {getLangTranslation("LOGIN_FORGOT_PASSWORD", "Forgot password")}
            </h2>
            <p className="text-center mb-6 light-text">
              {getLangTranslation(
                "FORGOT_PASSWORD_ENTER_YOUR_EMAIL_ADDRESS_DESC",
                "Enter your e-mail address to receive the code"
              )}
            </p>
            <div className="mb-6">
              <label htmlFor="email" className="form-label">
                {getLangTranslation("EMAIL", "Email")}
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder={getLangTranslation("EMAIL", "Email")}
                value={email}
                onChange={handleInputChange}
              />
              {
                error && (
                  <div className="text-danger my-2">
                    {getLangTranslation(error, "Email is required")}
                  </div>
                )
              }
            </div>


            <div className="d-grid">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={loader}
              >
                {loader ? (
                  <LoadingIndicator width={100} height={40} />
                ) : (
                  <span className="btn-upper-case">
                    {getLangTranslation("SAVE", "Save")}
                  </span>
                )}
              </button>
            </div>
            <p className="text-center my-6 fw-semibold">
              {getLangTranslation("FORGOT_PWD_DONT_HAVE_ACC")}{" "}
              <Link to="/auth/create-an-account" className="ms-3">
                {getLangTranslation("LOGIN_CHILD_SIGN_UP", "Sign Up")}
              </Link>
            </p>
            {/* <p className="text-center fw-semibold">
              {getLangTranslation('BY_SIGNING_IN')} <a href="#a">Terms of Service</a> and <a href="#a">Privacy Policy</a>
            </p> */}
            <AuthTermsService />
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
